import { googleAutoCompleteApi, getDetailsByPlaceID } from '../../api/locationApi';
import {
  FETCH_LOCATION,
  FETCH_LOCATION_SUCCESS,
  FETCH_LOCATION_FAILS,
  FETCH_LOCATION_DETAILS,
  FETCH_LOCATION_DETAILS_SUCCESS,
  FETCH_LOCATION_DETAILS_FAILS
} from './locationActionTypes';

export const getLocation = add => {
  return dispatch => {
    dispatch({
      type: FETCH_LOCATION
    });
    googleAutoCompleteApi(add)
      .then(res => {
        dispatch({
          type: FETCH_LOCATION_SUCCESS,
          payload: res.data
        });
      })
      .catch(error => {
        dispatch({
          type: FETCH_LOCATION_FAILS,
          payload: error
        });
      });
  };
};

export const getLocationDetails = placeId => {
  return dispatch => {
    dispatch({
      type: FETCH_LOCATION_DETAILS
    });
    getDetailsByPlaceID(placeId)
      .then(res => {
        dispatch({
          type: FETCH_LOCATION_DETAILS_SUCCESS,
          payload: res.data.result
        });
      })
      .catch(error => {
        dispatch({
          type: FETCH_LOCATION_DETAILS_FAILS,
          payload: error
        });
      });
  };
};
